import { log as rendererLog } from "../logging";
/** @deprecated Use log method from renderer directly */
export function log(level, message, metadata) {
    rendererLog(level, message, metadata);
}
